import { Box, BoxProps } from '@mui/material';
import { type FC } from 'react';

export interface GateFigureProps {
  boxProps?: BoxProps;
}

export const GateFigure: FC<GateFigureProps> = ({ boxProps }) => {
  return (
    <Box {...boxProps} alt="Figura de compuerta" component="img" src={`/static/gate-figure.png`} />
  );
};
